var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{ref:"dtComponent",attrs:{"modelData":_vm.dtData,"combineData":{value:['start', 'end'], dateFormat: true, join: ' - '},"activeFieldName":"is_active"},on:{"deleteItem":_vm.deleteCampaignItem,"activeHandled":_vm.campaignActiveUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }